import {
    ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output
} from '@angular/core';
import { Router } from '@angular/router';
import { AdditionalInfoService } from '@services/additional-info.service';
import { UserService } from '@services/user.service';

@Component({
  selector: 'app-id-expired-force-logout',
  templateUrl: './id-expired-force-logout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IdExpiredForceLogoutComponent {
  @Input() msg: string = '';
  @Input() status: string = '';
  @Output() closeModal = new EventEmitter<void>();
  private readonly infoService = inject(AdditionalInfoService);

  constructor(
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit() {
    if (this.status + '' === '401') {
      this.userService.logout().subscribe();
    }
  }

  logOut() {
    this.userService.logout().subscribe();
  }
}
